import { setMessagesAsRead } from '../../actions/messages';
import { CHATBOT_ID } from '../../constants/chatbotId';
import {
  fetchMessagesRead,
  TMessagesReadRequest as TMessagesReadRequest_1,
  TMessagesReadResponse,
} from '../../repositories/chats/v1/messages/read';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction, TThunkDispatch } from '../../types/redux/thunk';
import { ETelemetryEvents } from '../../types/telemetry';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

const DEFAULT_ERROR_MESSAGE = 'Не удалось пометить сообщения как прочитанные';

// FIXME параметра messageIds нет в ручке, но чинить это будем позже
type TMessagesReadRequest = TMessagesReadRequest_1 & { messageIds: string[] };

/**
 * Пометить группу сообщений как прочитанные
 * @param parameters.chatId id чата
 * @param parameters.messageIds массив id сообщений
 */
/* istanbul ignore next */
export const markMessagesAsRead =
  (parameters: TMessagesReadRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const {
      httpApi,
      logger,
      telemetry,
      custom: { messagesMap },
    } = context;
    const { chatId, messageIds } = parameters;

    if (chatId === CHATBOT_ID) {
      dispatch(setMessagesAsRead({ chatId, messageIds, messagesMap }));

      return;
    }

    try {
      const { response, statusCode }: TMessagesReadResponse = await fetchMessagesRead({
        httpApi,
        parameters: { chatId },
        config: { requestConfig: { withCredentials: true } },
      });

      if (statusCode !== 200) {
        throw getResponseError({
          domain: EExceptionDomain.Messages,
          response,
          defaultMessage: DEFAULT_ERROR_MESSAGE,
          statusCode,
        });
      }

      telemetry.increment(ETelemetryEvents.MarkMessagesAsReadSuccess);

      dispatch(setMessagesAsRead({ chatId, messageIds, messagesMap }));
    } catch (ex) {
      telemetry.increment(ETelemetryEvents.MarkMessagesAsReadFail);

      const exception = getGenericLikeError({
        error: ex,
        domain: EExceptionDomain.Messages,
        message: DEFAULT_ERROR_MESSAGE,
      });

      logger.warning(exception, {
        microserviceName: 'chats',
        pathApi: '/v1/messages/read/',
        parameters: JSON.stringify({ chatId }),
      });
    }
  };

let timeout: ReturnType<typeof setTimeout>;

const MARK_MESSAGE_AS_READ_TIMEOUT = 5000;

export const markMessagesAsReadWithTimeout = (parameters: TMessagesReadRequest) => (dispatch: TThunkDispatch) => {
  clearTimeout(timeout);

  timeout = setTimeout(() => {
    clearTimeout(timeout);
    dispatch(markMessagesAsRead(parameters));
  }, MARK_MESSAGE_AS_READ_TIMEOUT);
};
